import React from 'react';
import ReactDOM from 'react-dom';
import ICoursera from './Images/coursera.jpg'
import CertCC from './Images/certificateCloudComputing.png'
import AWSCer from './Images/AWSCer.jpg'
import Cisco from './Images/cisco.jpeg'
import AWSRE from './Images/AWS.jpg'
import './Honor.css';

class Honor extends React.Component {
  render (){
    return (
      <div class="container-fluid text-center  " id="honor">
        <h2 class="downMarg">HONORS & AWARDS</h2>
        <div class="row text-center">
          <div class="col-sm-4 ">
            <div class="thumbnail">
              <img src={AWSRE} width="70%" height="50%" />
              <p><strong>AWS Fundamentals: Going Cloud Native</strong></p>
              <p><a href="https://www.coursera.org/" target="_blank">Coursera course offered By AWS</a></p>
              <a href="https://www.coursera.org/account/accomplishments/certificate/87KJ7MXSYD2U" target="_blank">See credential</a>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="thumbnail">
              <img src={CertCC}  width="70%" height="50%"  />
              <p><strong>Cloud Computing Certification</strong></p>
              <p><a href="http://online.illinois.edu/online-programs/graduate-programs/natural-resources-environmental-sciences?gclid=CjwKCAjwkenqBRBgEiwA-bZVtngCcI2r_12WvJX29uXSb1KBgmquZin93tvlDAvfmfzqeACCSRnv3xoCqCQQAvD_BwE" target="_blank">Illinois University</a></p>
              <a href="https://www.coursera.org/account/accomplishments/certificate/ZGCALHRRRLGG" target="_blank">See credential</a>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="thumbnail">
              <img src={Cisco}  width="70%" height="50%"  />
              <p><strong>Cisco Networking Basics Specialization</strong></p>
              <p><a href="https://www.netacad.com/fr" target="_blank">Cisco Academy</a></p>
              <a href="https://www.coursera.org/account/accomplishments/certificate/CE29NS39T7KM" target="_blank">See credential</a>
            </div>
          </div>
          <div class="row text-center">
            <div class="col-sm-4">
              <div class="thumbnail">
                <img src={AWSCer} width="70%" height="50%" />
                <p><strong>AWS For Beginners Certification</strong></p>
                <p> <a herf="https://www.eduonix.com/" target="_blank">Eduonix Learning Solutions</a></p>
                <a href="https://www.udemy.com/certificate/UC-DUYUO7X1/?utm_campaign=email&utm_source=sendgrid.com&utm_medium=email" target="_blank">See credential</a>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
    )
  }
}
export default Honor
